/**
 * Small formatting helpers used across pages.
 */
import { FIGHTER_STATUSES } from "./constants";

export const formatDateFR = (iso, { withTime = false, withGmtTime = false } = {}) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const opts = { day: "2-digit", month: "long", year: "numeric" };
  const date = d.toLocaleDateString("fr-FR", opts).toUpperCase();
  if (withGmtTime) {
    const gmt = formatEventTimeGMT(iso);
    return gmt ? `${date} · ${gmt}` : date;
  }
  if (!withTime) return date;
  const time = d.toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${date} · ${time}`;
};

// Phase 13.2 — L'événement est stocké en UTC et interprété en heure du
// Burkina Faso (GMT/UTC+0). Retourne "19H00 GMT" quand l'heure est
// renseignée (≠ 00:00 UTC), sinon `null` — l'appelant décide ce qu'il
// affiche. Convention forte : 00:00 UTC = « heure non définie ».
export const formatEventTimeGMT = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const h = d.getUTCHours();
  const m = d.getUTCMinutes();
  if (h === 0 && m === 0) return null;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(h)}H${pad(m)} GMT`;
};

export const formatShortDateFR = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d
    .toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" })
    .toUpperCase();
};

export const statusLabelFR = (status) => FIGHTER_STATUSES[status] || status;
